var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCaramel = function SvgCaramel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 270 270"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#caramel_svg__a)",
    d: "M206 99.47v71.06a9.99 9.99 0 0 1-4.97 8.64l-61.01 35.48a10.01 10.01 0 0 1-10.04 0l-61.01-35.48a9.99 9.99 0 0 1-4.97-8.64V99.47a9.99 9.99 0 0 1 4.97-8.64l61.01-35.48a10.01 10.01 0 0 1 10.04 0l61.01 35.48a9.986 9.986 0 0 1 4.97 8.64"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "caramel_svg__a",
    x1: 135,
    x2: 135,
    y1: 203.364,
    y2: 62.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B89BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })))));
};
export default SvgCaramel;